import React from 'react';
import CopyLink from 'js/components/buttons/share/copy_link';
import ShareButton from 'js/components/buttons/share/share_button';

const SharePanel = (props) => {
  const url = platform => `${
    props.shareUrl
  }?utm_source=${platform}&utm_medium=social_share&utm_campaign=${
    props.utmCampaign
  }`;

  return (
    <div className="share__container">
      <ShareButton
        url={url('whatsApp')}
        platform={'whatsApp'}
        title={props.title}
        text={true}
      />
      <ShareButton url={url('messenger')} platform={'messenger'} text={true} />
      <ShareButton url={url('facebook')} platform={'facebook'} text={true} />
      <ShareButton
        url={url('twitter')}
        platform={'twitter'}
        title={props.title}
        text={true}
      />
      <ShareButton
        url={url('email')}
        platform={'email'}
        title={props.title}
        text={true}
      />
      <CopyLink input="#uniqueReferralAddress" text={true} />
    </div>
  );
};

export default SharePanel;
